export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10156.23c3d334.jpg";